import { Button, Card, CardContent, Container, Grid, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import { useLoadingContext } from '../../context/loadingContext';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { LadingService } from '../../Services/landing.service';
import { CKEditorComponent } from '../CKEditor';

const EditLanding = () => {
    const navigate = useNavigate();
    const [landing, setLanding] = useState({});
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [image, setImage] = useState('');
    const [imgReview, setImgReview] = useState(null);
    const { handleStartLoading, handleStopLoading } = useLoadingContext()

    useEffect(() => {
        getLandingById().finally(handleStopLoading);
    }, []);

    const getLandingById = async () => {
        handleStartLoading()
        const landingData = await LadingService.GetLandingId(id);
        setLanding(landingData)
        setTitle(landingData.title);
        setContent(landingData.content);
        setImgReview(`${process.env.REACT_APP_IMAGE}${landingData.image}`);

    };
    const handleAvatarChange = (e) => {
        const img = e.target.files[0];
        const review = URL.createObjectURL(img);
        setImgReview(review);
        setImage(img);
    };
    const handleCancelClick = () => {
        navigate(-1);
    };

    const handleEditClick = async () => {
        const form = new FormData();
        form.append('title', title);
        form.append('content', content);
        form.append('image', image);
        try {
            handleStartLoading()
            await LadingService.EditLanding(id, form);
            navigate(`/landing`, { replace: true, state: '/landing' });
        } catch (error) {
            console.log(error)
        } finally {
            handleStopLoading()
        }
    }
    return (
        <Page title="Create event">
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Edit landing
                    </Typography>
                    <Stack direction={'row'} spacing={1}>
                        <Button
                            type="button"
                            onClick={handleCancelClick}
                            color="error"
                            variant="contained"
                            startIcon={<Iconify icon="iconoir:cancel" />}
                        >
                            Cancel
                        </Button>
                        <Button
                            //   disabled={isSubmitting} 
                            onClick={handleEditClick}
                            type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                            Save
                        </Button>
                    </Stack>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                            <Grid item xs={12} md={8}>
                                <Stack spacing={3}>
                                    <TextField id="outlined-basic" label="Title" variant="outlined" value={title} onChange={e => setTitle(e.target.value)} />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Button
                                    // disabled={isSubmitting}
                                    sx={{ border: '1px dashed gray' }}
                                    color="primary"
                                    aria-label="upload picture"
                                    component="label"
                                >
                                    <input
                                        onChange={handleAvatarChange}
                                        hidden accept="image/*" type="file" />
                                    {imgReview ? (
                                        <img
                                            src={imgReview}
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <img
                                            src="/static/noimage.jpeg"
                                            alt="noimage"
                                            width={'300px'}
                                            height={'180px'}
                                            style={{ objectFit: 'cover' }}
                                        />
                                    )}
                                </Button>
                            </Grid>
                        </Grid>
                        <CKEditorComponent
                            // disabled={isSubmitting}
                            placeholder={'Nội dung khuyến mãi'}
                            onValueChange={setContent}
                            value={content}
                        />
                    </CardContent>
                </Card>
            </Container>
        </Page>
    )
}

export default EditLanding